import React from 'react';
import { RegisterManager } from '~/presentation/pages';

export const MakeRegisterManagerPage: React.FC = () => {
  return <RegisterManager />;
};
